import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LiveChatScriptDataService } from '../../services/live-chat-script-data.service';
import { catchError, tap } from 'rxjs/operators';
@Component({
  selector: 'ai-chatbot-dialog',
  templateUrl: './ai-chatbot-dialog.component.html',
  styleUrls: ['./ai-chatbot-dialog.component.scss']
})
export class AIChatbotDialogComponent implements OnInit {

  aIChatbotStatus: boolean = false;

  buttonLoading: boolean = false;

  messages$ = this.liveChatScriptDataService.messages$;

  constructor(
    private dialogRef: MatDialogRef<AIChatbotDialogComponent>,
    private liveChatScriptDataService: LiveChatScriptDataService,
  ) { }

  ngOnInit() {
    this.liveChatScriptDataService.getAIChatbotStatus().subscribe(status => this.aIChatbotStatus = status);
  }

  onUpdateStatus() {
    this.buttonLoading = true;
    this.liveChatScriptDataService.updateAIChatbotStatus(this.aIChatbotStatus).pipe(
      tap(res => {
        this.buttonLoading = false;
        this.onCloseDialog();
      }),
      catchError(err => {
        this.buttonLoading = false;
        throw err;
      })
    ).subscribe();
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

}


